import { IonPage } from '@ionic/react';
import { useAtom } from 'jotai';
import React from 'react';
import { ComponentType } from 'react';
import { RouteProps } from 'react-router';
import { Redirect, Route } from 'react-router-dom';

import { accessTokenAtom } from '../../store/Atoms';
import { useCustomRouter } from '../../utils/hooks/useCustomRouter';

interface GuardedRouteProps extends RouteProps {
    component: ComponentType<any>;
}

const GuardedRoute: React.FC<GuardedRouteProps> = ({
    component: Component,
    ...rest
}) => {
    const router = useCustomRouter();
    const [accessToken] = useAtom(accessTokenAtom);

    return (
        <Route
            {...rest}
            render={(props) => {
                return accessToken ? (
                    <Component {...props} />
                ) : (
                    <IonPage>
                        <Redirect
                            exact
                            to={{
                                pathname: '/login',
                                state: {
                                    from: router.routeInfo.lastPathname || '/',
                                },
                            }}
                        />
                    </IonPage>
                );
            }}
        />
    );
};

export default GuardedRoute;
